import { useGetList } from 'react-admin';

const useCheckIns = (job_id: number) =>
  useGetList('CheckIn', {
    filter: {
      search: {
        job_id,
      },
    },
  });

export default useCheckIns;
